<ng-container
  *ngIf="
    !isDropdownChip &&
    !splitActionRightIcon &&
    !splitActionRightLabel &&
    (!removed || (!removable && removed))
  "
>
  <div
    class="chip"
    [class.active]="active"
    [class.pointer]="toggleType === 'toggle'"
    [class.toggle-hover]="toggleType === 'toggle'"
    (click)="handleActionLeft()"
  >
    <span
      *ngIf="icon"
      [class]="icon"
      class="basin-font-size-16 basin-mr-1"
      (click)="handleIconClick($event)"
    ></span>
    <div
      [class.no-icon]="!icon"
      [class.no-removable]="!removable"
      [class.basin-mr-1]="removable"
    >
      {{ label }}
    </div>
    <span
      *ngIf="removable"
      class="remove-icon basin-font-size-16 pointer"
      [class]="markedToRemove ? 'icon-cancel' : 'icon-highlight-off'"
      (click)="removeChip($event)"
    ></span>
  </div>
</ng-container>

<ng-container
  *ngIf="
    !isDropdownChip &&
    (splitActionRightIcon || splitActionRightLabel) &&
    (!removed || (!removable && removed))
  "
>
  <div class="split-chip-container">
    <div
      class="chip split-chip"
      [class.active]="active"
      [class.pointer]="
        toggleType === 'toggle' ||
        (toggleType === 'switch' && activeSwitch != 'left')
      "
      [class.active-switch]="activeSwitch === 'left'"
      (click)="handleActionLeft()"
    >
      <span
        *ngIf="icon"
        [class]="icon"
        class="basin-font-size-16 basin-mr-1"
      ></span>
      <div [class.no-icon]="!icon" class="basin-mr-1">{{ label }}</div>
    </div>
    <div
      *ngIf="splitActionMiddleIcon || splitActionMiddleLabel"
      class="split-action-middle pointer"
      [class.active]="active"
      [class.pointer]="activeSwitch != 'middle'"
      [class.active-switch]="activeSwitch === 'middle'"
      (click)="handleActionMiddle()"
    >
      <span
        [class]="splitActionMiddleIcon"
        class="basin-font-size-16"
        [class.basin-mr-1]="splitActionMiddleLabel"
      ></span>
      <div class="basin-font-size-12">
        {{ splitActionMiddleLabel }}
      </div>
    </div>
    <div
      *ngIf="
        !splitActionMenuItems || (splitActionMenuItems && splitActionMiddleIcon)
      "
      class="split-action-right pointer"
      [class.active]="active"
      [class.pointer]="activeSwitch != 'right'"
      [class.active-switch]="!splitActionMenuItems && activeSwitch === 'right'"
      (click)="handleActionRight()"
    >
      <span
        [class]="splitActionRightIcon"
        class="basin-font-size-16"
        [class.basin-mr-1]="splitActionRightLabel"
      ></span>
      <div class="basin-font-size-12">
        {{ splitActionRightLabel }}
      </div>
    </div>
    <div
      *ngIf="
        splitActionMenuItems &&
        (!splitActionMiddleIcon || !splitActionMiddleLabel)
      "
      class="split-action-right pointer"
      [class.active]="active"
      (click)="
        active ? splitActionMenu.toggle($event) : this.handleActionLeft()
      "
    >
      <span
        [class]="splitActionRightIcon"
        class="basin-font-size-16"
        [class.basin-mr-1]="splitActionRightLabel"
      ></span>
      <div class="basin-font-size-12">
        {{ splitActionRightLabel }}
      </div>
      <p-menu
        #splitActionMenu
        [popup]="true"
        [model]="splitActionMenuItems"
      ></p-menu>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isDropdownChip">
  <div class="chip-dropdown-wrapper">
    <div
      class="chip pointer toggle-hover"
      [class.active]="active"
      [class.dropdown-expanded]="dropdownExpanded"
      (click)="toggleDropdown()"
    >
      <span
        *ngIf="icon"
        [class]="active ? 'symbol-check' : icon"
        class="basin-font-size-16 basin-mr-1"
      ></span>
      <div class="basin-mr-1" [class.no-icon]="!icon">
        {{ label }}
      </div>
      <span
        class="basin-font-size-16"
        [class]="
          dropdownExpanded ? 'symbol-arrow-drop-up' : 'symbol-arrow-drop-down'
        "
      ></span>
      <div
        *ngIf="dropdownExpanded"
        class="dropdown-content basin-color-dark-gray"
        (click)="$event.stopPropagation()"
      >
        <ng-content select="[slot=dropdown-content]"></ng-content>
      </div>
    </div>
  </div>
</ng-container>
